import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartStepper"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M10.5 16.5V10.5H16.5V4.5H22.5V3H15V9H9V15H3V1.5H1.5V21C1.5005 21.3977 1.65869 21.7789 1.93989 22.0601C2.22108 22.3413 2.60233 22.4995 3 22.5H22.5V21H3V16.5H10.5Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartStepper.vue"]]);
